export const NAME = 'apiKeys';
export const FORM_NAME = 'apiKeysForm';
